import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ObsoleteProductComponent } from './obsolete-product.component';
import { SimpleToggleModule } from '../../../../../../components/form-elements/simple-toggle/simple-toggle.module';
import { CmsConfig, provideConfig } from '@spartacus/core';

@NgModule({
  declarations: [ObsoleteProductComponent],
  exports: [ObsoleteProductComponent],
  imports: [CommonModule, SimpleToggleModule],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        ObsoleteProduct: {
          component: ObsoleteProductComponent,
        },
      },
    }),
  ],
})
export class ObsoleteProductModule {}
